module.exports = __webpack_public_path__ + "img/bruce-wayne-cocktail.89c557db.jpg";